window.onload = function () {
  const submitButton = document.querySelector(
    '.js-footer-newsletter-form .klaviyo-form button[type="button"]'
  )
  const input = document.querySelector(
    '.js-footer-newsletter-form input[type="email"]'
  )
  const container = document.querySelector(
    '.js-footer-newsletter-form div[data-testid="form-row"]'
  )

  container.style = 'display: block;'
  submitButton.classList.add('opacity-0')

  input.addEventListener('focus', function () {
    container.style = 'display: flex;'
    submitButton.classList.remove('opacity-0')
  })

  let regex = new RegExp('[a-z0-9]+@[a-z]+.[a-z]{2,3}')

  submitButton.addEventListener('click', function (e) {
    document.cookie = 'newsletter=true; expires=10; path=/'

    setTimeout(() => {
      if (regex.test(input.value)) {
        $('.site-footer').removeClass('showNewsletter')
      }
    }, 250)
  })
}
